/**
 * @ngdoc service
 * @name app.newsService
 * @description
 * # newsService
 * Service to talk with backend api.
 * @requires app.apiService
 * @requires constants:config
 **/
/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * regionService
 \*---------------------------------------------------------*/
/* @ngInject */
function newsService(apiService, config) {
  // APIs
  /**
   * @ngdoc
   * @name app.newsService#getDataFeed
   * @methodOf app.newsService
   * @example
   * ``` js
   * newsService.getDataFeed('CT', 'local');
   * ```
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of two characters.
   * @param {string} category string passed showing current category.
   * @description
   * Service to talk with backend api. It calls the apiService.wrap function,
   * passing a relative url, the string '/news/datafeed/', and the passed in region code.
   * @returns {array} it will return an array ob objects with the properties 'image',
   * 'header', 'videoUrl', or  just an empty array, it will return an error if either
   * region or category are not entered, or entered incorrectly;;
   **/
  this.getDataFeed = (regionCode, category) => {
    if (!angular.isString(regionCode) || regionCode.length !== 2) {
      throw new Error('A two-character region code is required');
    }
    if (!angular.isString(category) || !category.length) {
      throw new Error('category is required');
    }
    return apiService.wrap(`${config.relBaseUrlAPi}/news/datafeed/${regionCode}/${category}`,
      {}, 'news')
      .then((res) => {
        if (!res.data) {
          return [];
        }
        const data = res.data.rss.channel.item;
        return data.map((s) => {
          return {
            image: s['media:content']['media:thumbnail'].url,
            header: s.title,
            videoUrl: s['media:content'].url
          };
        });
      });
  };
}

newsService.$inject = [
  'apiService',
  'config'
];

const api = angular
  .module('newsService', ['config', 'apiService'])
  .service('newsService', newsService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/news.js
 **/